import numeral from 'numeral'

export default {
  validate: value => numeral(value).value() > 0
}
